import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { I18nProvider } from "@/lib/i18n.jsx";
import StickyReviewBadge from "@/components/StickyReviewBadge.jsx";
import SeoSchema from "@/components/SeoSchema.jsx";
import CookieConsent from "@/components/CookieConsent.jsx";
import Home from "@/pages/Home.jsx";
import SummerCamp from "@/pages/SummerCamp.jsx";
import WinterCamp from "@/pages/WinterCamp.jsx";
import PrivacyPolicy from "@/pages/PrivacyPolicy.jsx";

function App() {
  return (
    <div className="App">
      <I18nProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/lato" element={<SummerCamp />} />
            <Route path="/zima" element={<WinterCamp />} />
            <Route path="/summer" element={<SummerCamp />} />
            <Route path="/winter" element={<WinterCamp />} />
            <Route path="/polityka-prywatnosci" element={<PrivacyPolicy />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            {/* legacy/incoming deep links – redirect to home anchors */}
            <Route path="/skatepark" element={<Navigate to="/#skatepark" replace />} />
            <Route path="/dla-rodzicow" element={<Navigate to="/#dla-rodzicow" replace />} />
            <Route path="/wazne-informacje" element={<Navigate to="/#info" replace />} />
            <Route path="*" element={<Home />} />
          </Routes>
          <StickyReviewBadge />
          <SeoSchema />
          <CookieConsent />
        </BrowserRouter>
        <Toaster position="bottom-right" />
      </I18nProvider>
    </div>
  );
}

export default App;
